<template>
  <el-dialog title="添加测量工具"
             :visible.sync="dialogVisible"
             custom-class="lx-dialog"
             :close-on-click-modal="false"
             @open="handleOpen"
             @close="closeDialog">
    <el-checkbox-group v-model="checkedTool"
                       style="margin-top: 10px">
      <el-checkbox-button v-for="item of toolData"
                          :key="item.value"
                          :label="item.value">{{ item.name }}</el-checkbox-button>
    </el-checkbox-group>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="small"
                 @click="$emit('update:visible', false)">取 消</el-button>
      <lx-submit btn-size="small"
                 btn-type="primary"
                 :btn-disabled="isBtnDisabled"
                 @click.native="submitProjectModel">确 定</lx-submit>
    </div>
  </el-dialog>
</template>

<script>
import Submitting from '@/components/common/Submitting'
export default {
  props: ['visible', 'apiIndentity'],

  data () {
    return {
      checkedTool: [],
      resourceType: '',
      resourceName: '',
      resourceData: [],
      toolData: [],
      isBtnDisabled: false
    }
  },

  components: { 'lx-submit': Submitting },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    }
  },

  mounted () {
  },

  methods: {
    getPageData () {
      // this.$xhrGet(`/teaching/existmeasuretool`)
      //   .then(rs => {
      //     this.checkedTool = rs.toolValue
      //   })
      let queryParam = {
        trainProjectItemId: this.apiIndentity
      }
      this.$xhrGet('/projects/tools', queryParam)
        .then(rs => {
          this.toolData = rs.data
        })
    },
    handleOpen () {
      this.getPageData()
      this.isBtnDisabled = false
    },

    closeDialog () {
      this.checkedTool = []
      this.resourceType = ''
      this.resourceName = ''
      this.resourceData = []
      this.toolData = ''
      this.$emit('edit-result', this.form)
      this.$emit('update:visible', false)
    },

    submitProjectModel () {
      this.isBtnDisabled = true
      let toolParam = {
        'resourceToolIds': this.checkedTool
      }
      if (!this.checkedTool.length) {
        this.$message.error('请选择测量工具!')
        this.isBtnDisabled = false
        return
      }
      this.$xhrPost(`/projects/items/${this.apiIndentity}/tools`, toolParam)
        .then(rs => {
          if (rs.code === 200) {
            this.closeDialog()
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/teaching/ToolEditor.vue